import { createCardRoutes } from "lib/core/routing/card-routing"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import { cohortFeaturesCardRoutes } from "../group/components/manage/features-routes"

const basePath = "/library/:resourceSlug/:cohortId/:section/"

export default createCardRoutes(
  basePath,
  cohortFeaturesCardRoutes,
  LibraryResourceContainer
)
